import { formatPersianDateLong } from "@/lib/format/persian";

export function useDashboardDate() {
  return formatPersianDateLong();
}
